import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateCostProfileRequestFailure() {
      return getState().isFailure;
    },
    isCreateCostProfileRequestPending() {
      return getState().isPending;
    },
    isCreateCostProfileRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
